import { render, staticRenderFns } from "./AboutContentListItem.vue?vue&type=template&id=0d5b7ad9&scoped=true&"
import script from "./AboutContentListItem.vue?vue&type=script&lang=js&"
export * from "./AboutContentListItem.vue?vue&type=script&lang=js&"
import style0 from "./AboutContentListItem.vue?vue&type=style&index=0&id=0d5b7ad9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5b7ad9",
  null
  
)

export default component.exports